import React from 'react';
import {useNavigate} from "react-router-dom";
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/CardWithTitle.module.css";
import PressNDate from "./PressNDate";



const CardWithTitle = ({news}) => {

    const navigate = useNavigate()
    const moveToSingleNews = () => {navigate(`/single-news/${news.newsid}`)}
    const moveToTimeline = () => {navigate(`/${news.newsid}/timeline`)}

    return (
        <div className={styles.card_container} >
            <div className={styles.card_top} onClick={moveToSingleNews}>
                <RatingIndicator signal={news.signal} percent={news.staticsentimental.percent}/>
                <p className={styles.title}>{news.subject}</p>
            </div>

            <div className={styles.card_footer}>
                <span className={styles.stockname}>{news.stockname}</span>
                {/*<span>{news.press}·{news.registdate.slice(-5)}</span>*/}
                <PressNDate press={news.press} date={news.registdate}/>
                {news.samenewscounts>0 && <span className={styles.newscnt} onClick={moveToTimeline}>연관뉴스 {news.samenewscounts}건 보기 > </span>}
            </div>
        </div>

    );
}

export default CardWithTitle;
